module.exports = __webpack_public_path__ + "img/icon-mapmatch-b6d18ec8.svg";